<div *ngIf="show">
  <form *ngIf="piData" [formGroup]="otherNameform" (ngSubmit)="onSubmit()">
    <!-- show horizonally -->
    <div class="flex-wrapper">
      <div class="fx-flex-40">
        <div class="is-taller">
          <div class="level">
            <div class="level-item">
              <h2 class="bofa--heading is-6">Enter your other name(s)</h2>
            </div>
          </div>
        </div>

        <div *ngFor="let otherForm of otherNameList.controls; let i = index" [formGroup]="otherForm">
          <div>
            <mat-accordion *ngIf="step === i">
              <mat-expansion-panel [class.border]="border" [expanded]="step === i" [hideToggle]="true"
                (opened)="setStep(i)" class="af-mat-card mat-elevation-z">
                <mat-expansion-panel-header class="mat-expansion outlined">
                  <mat-panel-title>
                    Name {{i+1}}
                  </mat-panel-title>
                  <mat-panel-description>
                    <div tabindex="0" (keyup.enter)="deleteClick(i)" (click)="deleteClick(i)">
                      <img role="img" src="assets/bofa_icon_close2_186rgb.svg" alt="remove other name" />
                    </div>
                  </mat-panel-description>
                </mat-expansion-panel-header>

                <!-- set focus when pressing Add button -->
                <div tabindex="-1" #addElement class="bofa--skiplink"></div>

                <mat-form-field class="max-width minor-list-space"
                  hideRequiredMarker>
                  <mat-label><abbr title='required'>* </abbr>Name type</mat-label>
                  <mat-select formControlName="nameType" required>
                    <mat-option>Select</mat-option>
                    <mat-option *ngFor="let nameType of piData.nameTypeLookup | keyvalue : valueAscOrder"
                      [value]="nameType.key">
                      {{nameType.value}}
                    </mat-option>
                  </mat-select>
                  <mat-hint class="bofa--skiplink">{{ dropDownScreenReaderNameType(otherForm) }}</mat-hint>
                  <mat-error *ngIf="otherForm.controls.nameType.hasError('required') ">Please select Name type
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="max-width minor-list-space"
                  hideRequiredMarker>
                  <mat-label><abbr title='required'>* </abbr>First name</mat-label>
                  <input matInput formControlName="otherFirstName" required maxlength="100">
                  <mat-error>Please enter valid First name</mat-error>
                </mat-form-field>

                <div>
                  <mat-form-field class="max-width">
                    <mat-label>Middle name (optional)</mat-label>
                    <input matInput formControlName="otherMiddleName" maxlength="100">
                    <mat-error>Please enter valid Middle name</mat-error>
                  </mat-form-field>
                </div>

                <mat-form-field class="max-width minor-list-space"
                  hideRequiredMarker>
                  <mat-label><abbr title='required'>* </abbr>Last name</mat-label>
                  <input matInput formControlName="otherLastName" required maxlength="100">
                  <mat-error>Please enter valid Last name</mat-error>
                </mat-form-field>

                <mat-form-field class="max-width" hideRequiredMarker *ngIf="piData.jobCountryValue !== 'India'">
                  <mat-label><abbr title='required'>* </abbr>Date of name change</mat-label>
                  <input matInput [matDatepicker]="picker" [min]="minDate" [max]="maxDate"
                    formControlName="dateNameChange" required maxlength="100">
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                  <mat-hint>Format mm/dd/yyyy</mat-hint>
                  <mat-error *ngIf="otherForm.controls.dateNameChange.errors">Please enter date of name change in the
                    format mm/dd/yyyy
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="max-width" *ngIf="piData.jobCountryValue === 'India'">
                  <mat-label>Date of name change</mat-label>
                  <input matInput [matDatepicker]="picker" [min]="minDate" [max]="maxDate"
                    formControlName="dateNameChange" maxlength="100">
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                  <mat-hint>Format mm/dd/yyyy</mat-hint>
                  <mat-error *ngIf="otherForm.controls.dateNameChange.errors">Please enter date of name change in the
                    format mm/dd/yyyy
                  </mat-error>
                </mat-form-field>
              
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </div>
      </div>

      <div class="fx-flex-60">
        <div>
          <div class="is-taller">
            <div class="level">
              <div>
                <h2 id="review" class="bofa--heading is-6 flex-heading">Review your
                  other name(s)</h2>
              </div>
              <div> <button #addButtonElement [disabled]="otherNameform.invalid"
                  type="button" class="bofa--button secondary" (click)="onAddOtherName()">Add
                  Name</button>
              </div>
            </div>
          </div>
          <mat-selection-list *ngIf="listCheck" aria-describedby="review"
            (selectionChange)="handleSelection($event)">
            <mat-list-option *ngFor="let otherForm of otherNameList.controls; let i = index" [value]="i"
              [selected]="step === i" (keyup.enter)="focusTarget()">

              <div class="is-taller">
                <div class="level">
                  <div class="level-item">

                    <label *ngIf=" !otherForm.invalid">
                      <img src="assets/bofa_icon_checkmark2.svg" class="review-icon"
                        alt="check completed name" role="img" /></label>
                    <label *ngIf=" otherForm.invalid">
                      <img src="assets/bofa_icon_alert.svg" class="review-icon" alt="error incomplete name" role="img" />
                    </label>
                    <span class="padd-left-10">{{i+1}}</span>
                  </div>

                  <div class="level-item level-overflow">
                    {{otherForm.controls.otherFirstName.value}}
                    {{otherForm.controls.otherMiddleName.value }} {{otherForm.controls.otherLastName.value }}
                  </div>

                  <div class="level-item padd-left-10">
                    {{otherForm.controls.dateNameChange.value | dateFormat }}
                  </div>
                </div>
              </div>
              <mat-divider aria-hidden="true"></mat-divider>
            </mat-list-option>
          </mat-selection-list>
        </div>
      </div>
    </div>

      </form>
</div>
